// @flow
export const APP_SETTINGS_ATTRIBUTE = 'app-settings';
export const GET_APP_SETTINGS = 'hive/app-settings/GET_APP_SETTINGS';
export const RECEIVE_APP_SETTINGS = 'hive/app-settings/RECEIVE_APP_SETTINGS';
export const SET_APP_SETTINGS = 'hive/app-settings/SET_APP_SETTINGS';

export const DISCOVER_FEATURES = {
    ACTIONS2: 'actions2',
    GROUPS: 'groups',
    HUE: 'hue'
};
export const DISCOVER_NEW_FEATURES = 'discover-new-features';



// WEBPACK FOOTER //
// ./src/core/state/app-settings/constants.js